import { render, staticRenderFns } from "./ContestCard.vue?vue&type=template&id=751d7f16"
import script from "./ContestCard.vue?vue&type=script&lang=js"
export * from "./ContestCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports